import { useState } from "react";
import "./dynamic-table.css";
import { formatAsEuro } from "../../helpers/helpers";
import { useAppContext } from "../../AppContext";
import { cardMachines, CardMachine, Device } from "../../file.interface";
import CloseIcon from "../svgs/closeIcon";

const DevicesDynamicTable: React.FC<{
  flowDevices: Device[];
}> = ({ flowDevices }) => {
  //
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedDevice, setSelectedDevice] = useState<number | null>(null);
  const { selectedContractDuration, dispatch, selectedPOSSolution } =
    useAppContext();

  const handleModal = (deviceID: number): void => {
    setSelectedDevice(deviceID);
    setShowModal(true);
  };

  const setCardMachine = (cardMachine: CardMachine) => {
    setShowModal(false);
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: {
        flowDevices: flowDevices.map((device, i) => {
          if (selectedDevice === i) {
            return {
              ...device,
              cardMachine: cardMachine,
              licenceFee: selectedPOSSolution?.getEPOSLicencePrice(i + 1) ?? 0,
            };
          }
          return {
            ...device,
            licenceFee: selectedPOSSolution?.getEPOSLicencePrice(i + 1) ?? 0,
          };
        }),
      },
    });
  };

  const removeDevice = (item: Device) => {
    const itemIndex = flowDevices.findIndex((device) => device.id === item.id);
    if (itemIndex !== -1) {
      let alreadyRemoved = false;
      let newFlow = flowDevices.filter((device) => {
        if (device.id === item.id && !alreadyRemoved) {
          alreadyRemoved = true;
          return false;
        }
        return true;
      });

      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          flowDevices: newFlow,
        },
      });
    }
  };

  return (
    <div className="product-table-main-container">
      {flowDevices.map((device, i) => {
        let devicePrice: string | number =
          device?.prices[selectedContractDuration];

        let deviceTitle: string = device.name;
        if (device.cardMachine !== null) {
          devicePrice =
            devicePrice + device.cardMachine?.prices[selectedContractDuration];
          deviceTitle = deviceTitle + " + " + device.cardMachine.name;
        }

        devicePrice += device.licenceFee;
        devicePrice = formatAsEuro(devicePrice);

        return (
          <div key={`${device.id}-${i}`}>
            <div style={{ margin: "0px 10px -20px 10px", textAlign: "right" }}>
              <CloseIcon
                width={10}
                height={10}
                onClick={() => removeDevice(device)}
              />
            </div>
            <div className="product-row-container">
              <div className="product-row-img">
                <img src={device.imageUrl} alt="" />
              </div>
              <div className="product-row-name">{deviceTitle}</div>
              <div
                className={`product-row-button ${
                  device.cardMachine ? "product-row-button-active" : ""
                }`}
                onClick={() => handleModal(i)}
              >
                {device.cardMachine
                  ? device.cardMachine.name
                  : "Choose terminal"}
              </div>
              <div className="product-row-price">{devicePrice}</div>
            </div>
            {i === flowDevices.length - 1 && flowDevices.length > 1 && (
              <>
                <div className="app-separator" />
                <div className="total-align-right">
                  Total:{" "}
                  {formatAsEuro(
                    flowDevices.reduce(
                      (total, item) =>
                        total +
                        item.prices[selectedContractDuration] +
                        (item.cardMachine?.prices[selectedContractDuration] ??
                          0) +
                        item.licenceFee,
                      0
                    )
                  )}
                </div>
              </>
            )}
            {i !== flowDevices.length - 1 && <div className="app-separator" />}
          </div>
        );
      })}

      <div className={`app-modal-overlay ${showModal && "modal-active"}`}>
        <div className="modal">
          <h3 className="title-screen">Choose your card machine</h3>
          <br></br>
          <div className="card-machine-container">
            {cardMachines.map((cardMachine, i) => {
              return (
                <div
                  key={`${cardMachine.id}-${i}`}
                  className="card-machine"
                  onClick={() => setCardMachine(cardMachine)}
                >
                  <img src={cardMachine.imageUrl} alt="" />
                  <div>
                    <div className="card-machine-title">{cardMachine.name}</div>
                    <div className="card-machine-price">
                      {formatAsEuro(
                        cardMachine.prices[selectedContractDuration]
                      )}{" "}
                      monthly
                    </div>
                    <div className="card-machine-description">
                      {cardMachine.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevicesDynamicTable;
